import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_notes extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_notes">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Notes</h2>
              <p>
                The record notes component allows the user to enter notes which
                are time-stamped and recorded against the user's ID. These notes
                are recorded sequentially.
              </p>
              <p>
                The record notes component stores an array of JSON text for each
                note. Each JSON text contains a timestamp, the user's first
                name, last name, user ID, and the text body of the note.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_notes"}
                name={"notes"}
                dataNameDefault={'"array_text_my_field"'}
                padding={true}
                hide={true}
                order={true}
                button={true}
                tabIndex={true}
                readOnly={true}
                displayName={true}
                onChangeEval={true}
                properties={[
                  {
                    property: "show_notes",
                    description: "Show or hides the notes in record card.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "show_notes_delete",
                    description:
                      "Show or hides the individual note delete button.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "show_button",
                    description:
                      "Show or hides the button opening the notes dialog window.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "show_private",
                    description:
                      "Show or hides private notes.",
                    defaults: "true, false default is true"
                  },
                  {
                    property: "show_private_option",
                    description:
                      "Show or hides the option to make your note private.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "function_link_open",
                    description:
                      "Function links allow you to open the dialog window from the Layout Action Menus.",
                    defaults: "true, false default is false"
                  }
                ]}
              />

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Notes Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Notes</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_notes"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"array_text_json_notes"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Notes"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"show_button"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_color"</span>:{" "}
                  <span className="jsonY">"#388E3C"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_font_color"</span>:{" "}
                  <span className="jsonY">"#FFFFFF"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_position"</span>:{" "}
                  <span className="jsonY">"left"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_width"</span>:{" "}
                  <span className="jsonY">200</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_notes;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_notes.js